import React from 'react';
import { Reveal } from '../Reveal';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
import { trackProofScoreCtaClick } from '../../lib/analytics';
import { SalesEnablementCarousel } from './SalesEnablementCarousel';

/**
 * Business-building assets — asset-first showcase, then a short Score close.
 */
export function SalesEnablement() {
  const {
    openDiagnostic,
    answeredCount
  } = useScore();
  const buttonLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleClick = () => {
    trackProofScoreCtaClick();
    openDiagnostic();
  };
  return <section className="bg-paper px-6 pb-0 pt-14 md:px-10 md:pt-20" data-id="element-982" data-mp="w2m416ptr5ij">
      <div className="mx-auto max-w-6xl" data-id="element-983" data-mp="w4fd0snwu1tp">
        <Reveal data-id="element-984" data-mp="s0r343bt2u5a">
          <SalesEnablementCarousel data-id="element-985" data-mp="s1acgvne4a7p" />
        </Reveal>
      </div>

      {/* Close — one beat, not a second chapter */}
      <div className="mt-10 bg-paper-dark/55 px-6 py-12 md:mt-12 md:px-10 md:py-14" data-id="element-986" data-mp="n38qo2ykxwsj">
        <Reveal delay={0.06} data-id="element-987" data-mp="5h4njoidonvx">
          <div className="mx-auto max-w-xl text-center" data-id="element-988" data-mp="5guufs21e0m0">
            <p className="font-serif text-2xl leading-snug text-navy md:text-[1.75rem]" data-id="element-989" data-mp="a95ucuws1mek">
              You do not have to assemble this yourself.
            </p>
            <div className="mt-6 flex justify-center" data-id="element-990" data-mp="3sl2dshtsb0jm">
              <Cta variant="primary" size="lg" showArrow onClick={handleClick} data-id="element-991" data-mp="jw29f1xo3qg">
                {buttonLabel}
              </Cta>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}